import React from 'react';
import { Typography } from '..';

const Tabs = ({ active, className, children, onClick }) => {
    return (
        <div
            onClick={() => onClick && onClick()}
            className={`${className} flex justify-center items-center h-full relative py-6 w-min cursor-pointer`}
        >
            <Typography
                variant="heading2.1"
                color={active ? 'brand-dark' : 'grey-dark'}
                className="transition-all hover:text-brand-main active:text-brand-dark"
            >
                {children}
            </Typography>
            <div
                className={`${
                    active ? 'block' : 'hidden'
                } transition-all absolute bottom-0 h-1 bg-brand-dark rounded-xl w-full`}
            />
        </div>
    );
};

export default Tabs;
